import editable from "@/domain/decorators/editable";

export default class ComponentToolingItem extends editable {
    componentBomID!: number;
    cmpToolingID!: number;
    cToolingItemCode!: number;
    bom!: number;
    cToolingQty!: number;
    fix!: boolean;
    rate!: number;
    extension!: number;
    cToolingComments!: string;
    toolingName!: string;
    cToolingLineNumber!: number;
    cToolingBlankCalcDnd!: boolean;

    show = true; // used to refresh components

    constructor(init?: Partial<ComponentToolingItem>) {
        super();
        Object.assign(this, init);
    }

    public compareTo(val: ComponentToolingItem): number {
        return this.cToolingLineNumber > val.cToolingLineNumber ? 1 :
            this.cToolingLineNumber === val.cToolingLineNumber ? 0 :
                -1;
    }

}
